import React, { useEffect, useState } from 'react';
import styles from './StaffMemberAdd.module.scss';
import { $t } from "../../helpers/translator";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { getClinics } from "../../store/data-slice";
import _ from "lodash";
import { $validate } from "../../helpers/formValidator";
import api from "../../helpers/api";
import { setAlert } from "../../store/alerts-slice";
import { getUserClinic } from "../../store/auth-slice";

const StaffMemberAdd = (props) => {
    const dispatch = useDispatch();
    const userType = useSelector((state) => state.auth.user.role)
    const [ clinicOptions, setClinicOptions ] = useState([])
    const [ clinicOptionsSelected, setClinicOptionsSelected ] = useState([])
    const [ formSent, setFormSent ] = useState(false)
    const [ payload, setPayload ] = useState({
        personal_id: props.staff ? props.staff.personalId : '',
        clinic_id: props.staff ? props.staff.clinic_id : '',
        email: props.staff ? props.staff.email : '',
        password: '',
        // phone: '',
        name: props.staff ? props.staff.name : '',
        id: props.staff ? props.staff.id : ''
    });

    const [ validations, setValidations ] = useState({
        clinic_id: {
            rules: [ 'required' ],
            errors: []
        },
        personal_id: {
            rules: [ 'required', 'minLength(5)', 'maxLength(30)', 'id' ],
            errors: []
        },
        name: {
            rules: [ 'required', 'minLength(3)', 'maxLength(30)', 'name' ],
            errors: []
        },
        email: {
            rules: [ 'email' ],
            errors: []
        },
        password: {
            rules: [ 'password' ],
            errors: []
        },
        // phone: {
        //     rules: ['numeric', 'minLength(8)', 'maxLength(15)'],
        //     errors: []
        // },
    });

    useEffect(async () => {
        if (userType === 2) {
            let clinic = await dispatch(getUserClinic())
            setPayload({ ...payload, clinic_id: clinic.id })
            return;
        }
        await getClinicOptions()
    }, [ dispatch ])      // like []. will only run once.

    async function getClinicOptions() {
        if (userType === 2) {
            return;
        }

        let res = await dispatch(getClinics())
        let clinics = [ ...res ];
        clinics.unshift({
            value: '',
            label: $t('global.staff.selectClinic'),
        })
        setClinicOptions(clinics);

        if (props.mode === 'edit' && props.staff) {
            // console.log(props.staff)
            // console.log(clinics)
            let clinicIndex = _.findIndex(clinics, function (o) {
                return o.id === props.staff.clinic_id;
            });
            if (clinicIndex) {
                setClinicOptionsSelected(clinics[ clinicIndex ])
                return;
            }
        }
        setClinicOptionsSelected(clinics[ 0 ])
    }

    async function formSentClickHandler() {
        setFormSent(true);
        //validating:
        let errorCount = 0;
        // console.log(payload)
        _.forEach(payload, (v, k) => {
            if (validations[ k ]) {
                errorCount += validateField(k, v, validations[ k ][ 'rules' ])
            }
        })

        if (!errorCount) {
            try {
                let res = props.mode === 'add' ? await api.post('/staff/create', payload) : await api.patch(`/staff/${payload.id}`, payload);
                if (res && res.success) {
                    dispatch(setAlert({ type: 'success' }))
                    props.emitClose();
                    return;
                }

                const error = res.data?.errors?.[ 0 ];
                if(typeof error === 'object') {
                    dispatch(setAlert({ body: error.error, type: 'error' }))
                } else {
                    dispatch(setAlert({ type: 'error' }))

                }
                console.error(error)
            } catch (e) {
                console.error(e);
            }
        }
    }

    function validateField(id, value, rules) {
        let errorsArr = $validate(value, rules)
        // console.log(id, value, rules, errorsArr)

        if(id === 'password') {
            if(payload.password === '') {
                errorsArr = []

                if(payload.email.length > 0) {
                    if(props.mode === 'add') {
                        errorsArr.push('Password is required if email is provided')
                    }
                }
            }
        }

        let newValidations = { ...validations }
        newValidations[ id ].errors = errorsArr;
        setValidations(newValidations)

        return errorsArr.length
    }

    return (
        <div>
            { props.visible && <div id='addStaffMemberModal' className={ styles.container }>
                <div className={ 'alma-box-header' }>
                    <div>
                        <h3>{ props.mode === 'add' ? $t('global.staff.addStaffMember') : $t('global.staff.editStaffMember') }</h3>
                    </div>
                </div>
                <div className={ 'alma-box-content' }>
                    <div className={ 'alma-fields-row' }>
                        {
                            userType > 2 ?
                                <div className={ 'alma-field-container' }>
                                    <div className={ 'alma-field-header' }>
                                        { $t('global.staff.clinic') }
                                    </div>
                                    <MultiSelect
                                        // tooltip={props.mode === 'edit' ? $t('global.staff.cannotChangeStaffClinic') : null}
                                        // disabled={props.mode === 'edit'}
                                        options={ clinicOptions }
                                        selected={ clinicOptionsSelected }
                                        onValueChange={ (data) => {
                                            setClinicOptionsSelected(data);
                                            setPayload({ ...payload, clinic_id: data.value });
                                            validateField('clinic_id', data.value, validations.clinic_id.rules)
                                        } }
                                    />

                                    <div
                                        className={ 'alma-field-error' }>{ formSent ? validations.clinic_id.errors[ 0 ] : '' }</div>
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.staff.name') }</div>
                            <input name="name"
                                // tooltip={$t('global.staff.cannotChangeStaffClinic')}
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ payload.name }
                                placeholder={ $t('global.staff.name') }
                                onChange={ (data) => {
                                    setPayload({ ...payload, name: data.target.value });
                                    validateField('name', data.target.value, validations.name.rules)
                                } } />
                            <div className={ 'alma-field-error' }>{ formSent ? validations.name.errors[ 0 ] : '' }</div>
                        </div>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.staff.personalId') }</div>
                            <input name="personal_id"
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ payload.personal_id }
                                placeholder={ $t('global.staff.personalId') }
                                onChange={ (data) => {
                                    setPayload({ ...payload, personal_id: data.target.value });
                                    validateField('personal_id', data.target.value, validations.personal_id.rules)
                                } } />
                            <div className={ 'alma-field-error' }>{ formSent ? validations.personal_id.errors[ 0 ] : '' }</div>
                        </div>
                    </div>
                    <div className={'alma-fields-row'}>
                        <div className={'alma-field-container'}>
                            <div className={'alma-field-header'}>{$t('global.staff.email')}</div>
                            <input name="email"
                                   className={`${'alma-input'}`}
                                   type="text"
                                   value={payload.email}
                                   placeholder={`${$t('global.staff.email')} (optional)`}
                                   onChange={(data) => {
                                       setPayload({...payload, email: data.target.value})
                                       validateField('email', data.target.value, validations.email.rules)
                                   }}/>
                            <div className={'alma-field-error'}>{formSent ? validations.email.errors[0] : ''}</div>
                        </div>
                    <div className={'alma-field-container'}>
                        <div className={'alma-field-header'}>Password</div>
                        <input name="password"
                               className={`${'alma-input'}`}
                               type="password"
                               value={payload.password}
                               placeholder={props.mode !== 'edit' ? `Password (optional)` : `(leave blank to keep current)`}
                               onChange={(data) => {
                                   setPayload({...payload, password: data.target.value})
                                   validateField('password', data.target.value, validations.password.rules)
                               }}/>
                        <div className={'alma-field-error'}>{formSent ? validations.password.errors[0] : ''}</div>
                    </div>
                    </div>
                </div>

                <div className={ 'alma-box-footer' }>
                    <div></div>
                    <div className={ 'alma-button' } onClick={ () => formSentClickHandler() }>
                        { props.mode === 'add' ? $t('global.staff.addStaffMember') : $t('global.staff.editStaffMember') }
                    </div>
                </div>
            </div> }
        </div>

    );
}

StaffMemberAdd.defaultProps = {
    mode: 'add',    //options: 'add', 'edit'
    staff: null,
}

export default StaffMemberAdd;
